'use client';
import TitleH1 from '../common/TitleH1';
import { usePathname } from 'next/navigation';

interface Props {
  title: string;
}

export default function TitleDividerBlock({ title }: Props) {
  const pathname = usePathname();
  const isHome = pathname === '/';
  const styles = isHome ? 'mt-[127px] xs:mt-[40px] text-center' : 'text-center';
  return (
    <TitleH1 size="huge" color="black" styles={styles}>
      <span dangerouslySetInnerHTML={{ __html: title }} />
    </TitleH1>
  );
}
